import type { StatsUsageRequestDto, StatsUsageResponseDto } from '../../types/api/stats';
import { BaseServiceClient } from '../BaseServiceClient';

interface StatsUsageServiceOptions {
  userStore?: any;
  storage?: any;
}

const EMPTY_USAGE_RESPONSE: StatsUsageResponseDto = { AccountId: '', Assessments: [] };

export class StatsUsageService extends BaseServiceClient {
  constructor(apiService: any) {
    super(apiService);
  }

  async getUsage(
    request: StatsUsageRequestDto,
    options?: StatsUsageServiceOptions
  ): Promise<StatsUsageResponseDto> {
    const response = await this.callService('stats_usage_get', request, 'data', {
      userStore: options?.userStore,
      storage: options?.storage,
    });

    const success = Boolean((response as any)?.success ?? (response as any)?.Success);
    if (!success) {
      throw new Error((response as any)?.message || (response as any)?.errorDescription || 'stats_usage_get failed');
    }

    const payload =
      (response as any)?.payload
      ?? (response as any)?.Payload
      ?? (response as any)?.result
      ?? (response as any)?.Result
      ?? (response as any)?.data
      ?? (response as any)?.Data
      ?? response;

    return this.parsePayload(payload);
  }

  private parsePayload(payload: unknown): StatsUsageResponseDto {
    if (typeof payload === 'string') {
      try {
        return { ...EMPTY_USAGE_RESPONSE, ...(JSON.parse(payload) as StatsUsageResponseDto) };
      } catch {
        return EMPTY_USAGE_RESPONSE;
      }
    }

    if (payload && typeof payload === 'object') {
      return { ...EMPTY_USAGE_RESPONSE, ...(payload as StatsUsageResponseDto) };
    }

    return EMPTY_USAGE_RESPONSE;
  }
}
